__turbopack_context__.v({
  "common": "dashboard-module-scss-module__B2vugW__common",
  "dashboard-page-main-con": "dashboard-module-scss-module__B2vugW__dashboard-page-main-con",
  "desktop-main-con": "dashboard-module-scss-module__B2vugW__desktop-main-con",
  "left": "dashboard-module-scss-module__B2vugW__left",
  "mobile-main-con": "dashboard-module-scss-module__B2vugW__mobile-main-con",
  "name-con": "dashboard-module-scss-module__B2vugW__name-con",
  "parent-con": "dashboard-module-scss-module__B2vugW__parent-con",
  "red-circle": "dashboard-module-scss-module__B2vugW__red-circle",
  "right": "dashboard-module-scss-module__B2vugW__right",
});
